<template>
  <div v-if="item" id="container" class="member_st">
    <div class="section fill">
      <div class="inner return_detail">
        <div class="box_title">
          <h2>{{ $t('views.member.requestreturn.2803') }}</h2>
          <!-- <p class="guide_txt">{{ $t('views.member.requestreturn.183') }}</p> -->
        </div>

        <ul class="info_text_wrap">
          <li class="tit">{{ $t('views.member.requestreturn.239') }}</li>
          <li>
            {{ $t('views.member.requestreturn.9697') }}<br />{{
              $t('views.member.requestreturn.1767')
            }}
          </li>
          <li>{{ $t('views.member.requestreturn.5847') }}</li>
          <li>{{ $t('views.member.requestreturn.1702') }}</li>
        </ul>

        <div class="mypage_detail">
          <div class="box">
            <div class="order_title">
              <dl>
                <dt>{{ $t('views.member.requestreturn.6116') }}</dt>
              </dl>
            </div>
            <ul class="order_book">
              <li class="join_check">
                <!-- UNUSED CHECKBOX FEATURE -->
                <!-- <div class="text_label">
                  <label>
                    <input type="checkbox" name="agree" class="" />
                    <em></em>
                    <span>선택</span>
                  </label>
                </div> -->

                <div class="cover_wrap">
                  <router-link
                    :to="{ name: 'book_detail', params: { id: item.bookCd } }"
                    class="thum_wrap"
                  >
                    <img :src="item.thumbUrl" alt="책제목" />
                  </router-link>
                </div>

                <div class="info_wrap">
                  <h3 class="meta_title">
                    {{ item.bookNm }}
                  </h3>
                  <p>
                    <span class="meta_author">{{ item.author }}</span>
                    <span class="gap">/</span>
                    <span class="meta_publisher">{{ item.publisher }}</span>
                  </p>
                  <p>
                    <span class="meta_order">{{
                      $t('views.member.requestreturn.6217')
                    }}</span>
                    <span class="meta_order_num">{{
                      $t('views.member.requestreturn.nbsp', {
                        '1': item.orderGoodsCd
                      })
                    }}</span>
                  </p>
                </div>

                <div class="price_wrap">
                  <ul class="meta_detail">
                    <li>
                      <p>
                        <span v-if="item.saleAmt">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="meta_price"
                            format-style="currency"
                            :currency="getCurrency.currency"
                            :number="item.saleAmt"
                          />
                        </span>

                        <span v-if="!item.saleAmt">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="meta_price"
                            format-style="currency"
                            :currency="getCurrency.currency"
                            :number="0"
                          />
                        </span>
                      </p>
                      <p class="meta_num">
                        {{ $t('common.ui.total') }}
                        <span class="num">{{ item.units || 0 }}</span
                        >{{ $t('common.ui.bookcount') }}
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="text_wrap">
          <ul>
            <li class="return_title fl">
              <p class="cell">{{ $t('views.member.requestreturn.3569') }}</p>
            </li>
            <li class="select_area fl">
              <div
                v-on-clickaway="closeReturnReasonMenu"
                class="select_item"
                :class="{ active: showReturnReasonMenu }"
                @click="toggleReturnReasonMenu"
              >
                <button class="select_option">
                  <span class="txt">{{
                    selectedReason
                      ? selectedReason.label
                      : '반품 사유를 선택해주세요'
                  }}</span
                  ><span class="arrow blind">열기</span>
                </button>

                <ul class="select_list" data-return-check="true">
                  <li class="tit">
                    {{
                      selectedReason
                        ? selectedReason.label
                        : '반품 사유를 선택해주세요'
                    }}
                    <button
                      type="button"
                      class="select_list_close an_a"
                      @click="closeReturnReasonMenu"
                    >
                      <span class="svg_close"></span
                      ><span class="an_t">{{
                        $t('library.deletemodal.close')
                      }}</span>
                    </button>
                  </li>
                  <li v-for="(option, idx) in returnReasons" :key="idx">
                    <button
                      type="button"
                      class="list_option"
                      :class="{
                        active:
                          selectedReason &&
                          option.value === selectedReason.value
                      }"
                      @click="selectReason(option)"
                    >
                      <span>{{ option.label }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <form class="input_form">
            <div class="input_wrap">
              <textarea
                v-model="returnReasonText"
                :placeholder="$t('views.member.requestreturn.6504')"
                class="input_t"
                name="comment"
                maxlength="250"
              ></textarea>
              <div style="margin-top: 20px;">
                <input
                  v-model="carrier"
                  class="additional_input"
                  type="text"
                  name="carrier"
                  :placeholder="$t('views.member.requestreturn.6308')"
                />
                <input
                  v-model="trackingNo"
                  class="additional_input"
                  type="text"
                  name="trackingNo"
                  :placeholder="$t('views.member.requestreturn.8621')"
                />
              </div>
              <div style="margin-top: 20px;">
                <h5>{{ $t('views.member.requestreturn.3429') }}</h5>
              </div>
            </div>
            <p class="txt_length">
              <span>{{ returnReasonText.length }}</span
              >{{ $t('views.member.requestreturn.7241') }}
            </p>
          </form>
        </div>

        <div class="btn_wrap">
          <a class="box_btn" @click="sendReturnRequest">
            <span class="an_t">{{
              $t('views.member.requestreturn.9677')
            }}</span>
          </a>
        </div>
      </div>
    </div>

    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ message }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleErrorModal">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import { ACCOUNT_ORDER_REQUEST_RETURN } from '@/store/types'
import { mapGetters } from 'vuex'

export default {
  name: 'RequestReturn',
  data() {
    return {
      // METHOD DATA
      showReturnReasonMenu: false,
      showErrorModal: false,
      message: '',
      item: null,
      carrier: '',
      trackingNo: '',

      // TEMP DATA
      // order details
      // order: {
      //   img: require('@/assets/images/cover/temp_book_cover.jpg'),
      //   title: '학교에서 알려주지 않는 17가지 실무 개발 기술',
      //   number: 'H0020200127',
      //   author: '홍길동',
      //   publisher: '출판천국',
      //   price: 24000,
      //   discount: 20,
      //   // Should pull the order discount the buyer got, not newly calculate it
      //   discountPrice: 20000,
      //   deliveryFee: 2500
      // },
      // Return reasons
      receiverName: '',
      returnReasons: [
        {
          label: '단순변심',
          value: 'RT0'
        },
        {
          label: '다른 상품 잘못 주문',
          value: 'RT1'
        },
        {
          label: '배송지연',
          value: 'RT2'
        },
        {
          label: '배송누락',
          value: 'RT3'
        },
        {
          label: '상품파손/불량',
          value: 'RT4'
        },
        {
          label: '상품정보와 다름',
          value: 'RT5'
        },
        {
          label: '오배송',
          value: 'RT6'
        },
        {
          label: '직접 입력',
          value: 'RT7'
        }
      ],
      selectedReason: null,
      returnReasonText: ''
    }
  },

  computed: {
    ...mapGetters(['getCurrency'])
  },

  mounted() {
    if (this.$route.params.item) {
      this.item = this.$route.params.item
    } else {
      this.item = this.order
    }
  },

  methods: {
    toggleErrorModal(message) {
      this.showErrorModal = !this.showErrorModal

      if (message) {
        this.message = message
      }
    },
    toggleReturnReasonMenu() {
      this.showReturnReasonMenu = !this.showReturnReasonMenu
    },
    closeReturnReasonMenu() {
      this.showReturnReasonMenu = false
    },
    selectReason(option) {
      this.selectedReason = option
    },
    async sendReturnRequest() {
      const purchase = {
        returnGoods: {
          reasonTp: this.selectedReason.value,
          reasonDesc: this.returnReasonText,
          carrier: this.carrier,
          trackingNo: this.trackingNo
        }
      }
      //const id = this.$route.params.id
      const id = this.item.orderGoodsCd

      try {
        await this.$store.dispatch(ACCOUNT_ORDER_REQUEST_RETURN, {
          id,
          purchase
        })
        this.$router.push({ name: 'orders' })
      } catch (err) {
        this.toggleErrorModal(
          `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn_wrap {
  margin-top: 120px;
  text-align: center;
  .box_btn {
    width: 320px;
    height: 48px;
    .an_t {
      font-size: 16px;
      line-height: 47px;
    }
  }
}
.additional_input {
  width: 48%;
  height: 48px;
  margin-right: 5px;
  background-color: #ffffff;
  border: 1px solid #d5dff3;
  padding: 10px;
  border-radius: 12px;
  font-family: 'Noto Sans KR';
  font-size: 15px;
  line-height: 28px;
  overflow: auto;
  resize: none;
}
</style>
